import CommonIFrame from 'components/atoms/CommonIFrame';

const JumpBackInViewAll = () => {
    return (
        <CommonIFrame
            id="all-alerts-view-all-iframe"
            src="https://fenkwsngfweikjsfhiwqefhieqhqfhiq.lovable.app/"
            title="Jump Back In - View All"
        />
    );
};

export default JumpBackInViewAll;
